import React from 'react';
import styled from 'styled-components';

const CardContainer = styled.div`
  background: ${props => props.theme.colors.cardBg};
  border-radius: ${props => props.$radius || '8px'};
  border: 1px solid ${props => props.theme.colors.border};
  padding: ${props => props.$padding || '0.5rem'};
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${props => props.$spacing || '0.5rem'};
  padding-bottom: 0.375rem;
  border-bottom: 1px solid ${props => props.theme.colors.border};
`;

const Title = styled.div`
  font-size: ${props => props.$size || '12px'};
  font-weight: 600;
  color: ${props => props.theme.colors.textPrimary};
`;

const Action = styled.div`
  font-size: 11px;
  color: ${props => props.theme.colors.primary};
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
`;

const Content = styled.div`
  min-height: ${props => props.$minHeight || 'auto'};
`;

/**
 * ChartCard Component
 * 
 * A card container for charts with optional title and action
 * 
 * @param {string} title - Card title
 * @param {string} action - Action text (e.g., "View All")
 * @param {Function} onAction - Action click handler
 * @param {ReactNode} children - Chart or content
 * @param {string} padding - Custom padding
 * @param {string} minHeight - Minimum content height
 * @param {boolean} showHeader - Show header section (default: true if title provided)
 * @param {string} className - Additional CSS class
 */
const ChartCard = ({
  title,
  action,
  onAction,
  children,
  padding,
  minHeight,
  showHeader,
  className
}) => {
  const shouldShowHeader = showHeader !== undefined ? showHeader : !!title;
  
  return (
    <CardContainer $padding={padding} className={className}>
      {shouldShowHeader && (
        <Header>
          {title && <Title>{title}</Title>}
          {action && <Action onClick={onAction}>{action}</Action>}
        </Header>
      )}
      <Content $minHeight={minHeight}>
        {children}
      </Content>
    </CardContainer>
  );
};

export default ChartCard;
